import React from 'react'
import Lottie from 'lottie-react'
import glassmorphismLoader from './glassmorphismLoader.json'

function GlassmorphismLoaging() {

    return (
        <div>   
            <Lottie animationData={glassmorphismLoader} loop={true} />
            
        </div>
    )
}

export default GlassmorphismLoaging
